// extracted by mini-css-extract-plugin
export default {"linkBox":"customlink_linkBox__9+r2b","iconBox":"customlink_iconBox__KfJhi"};